/**
 * <TraderJargon term="..."/> — plain-English label + hover tooltip when the
 * trader's saved `reading_level` is "basic" (default), or the raw technical
 * term undecorated when "intermediate"/"advanced". Mirrors the Super Admin
 * <Jargon/> component (components/admin/JargonTerm.jsx) but reuses the
 * EXISTING trader `reading_level` preference — no separate toggle/endpoint.
 */
import { Info } from "lucide-react";
import { Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { useAuth } from "@/context/AuthContext";
import { TRADER_GLOSSARY } from "@/lib/traderGlossary";

export function TraderJargon({ term, level, side = "top", className = "" }) {
    const { user } = useAuth() || {};
    const resolvedLevel = level || user?.reading_level || "basic";
    const g = TRADER_GLOSSARY[term];
    if (!g) return null;

    if (resolvedLevel !== "basic") {
        return <span className={className}>{g.technical}</span>;
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span
                    className={`inline-flex items-center gap-0.5 cursor-help border-b border-dotted border-muted-foreground/50 ${className}`}
                    data-testid={`trader-jargon-${term}`}
                >
                    {g.basic}
                    <Info className="w-3 h-3 opacity-60 shrink-0" />
                </span>
            </TooltipTrigger>
            <TooltipContent className="max-w-[240px] text-xs" data-testid={`trader-jargon-tooltip-${term}`} side={side}>
                <b>{g.technical}</b> — {g.definition}
            </TooltipContent>
        </Tooltip>
    );
}
